import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OrgDetailsModalComponent} from "./org-details-modal.component";
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {FormsModule} from "@angular/forms";
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [OrgDetailsModalComponent],
  imports: [
    CommonModule, FormsModule,
    AlertMessageModule,
    ButtonModule
  ],
  exports: [OrgDetailsModalComponent]
})
export class OrgDetailsModalModule { }
